// @flow
import {getCreator, postCreator, putCreator, deleteCreator} from '../../http';
import environment from '../../environment';
import type {OrderState} from '../../entities';

export const endpoints = Object.freeze({
  GET_ORDER: `${environment.baseApiUrl}/im/admin/order/:orderId`,
  GET_ORDER_STOCK_ERRORS: `${environment.baseApiUrl}/im/admin/order/:orderId/stock-errors`,
  UPDATE_ORDER_STATE: `${environment.baseApiUrl}/im/admin/order/:orderId/state`,
  ADD_ORDER_RECEIPT: `${environment.baseApiUrl}/im/admin/order/:orderId/receipt`,
  // GET_AVAILABLE_REVERT_STATES: `${environment.baseApiUrl}/im/admin/order/:orderId/state/available-revert`,
  GET_PRE_ORDER: `${environment.baseApiUrl}/im/admin/pre-order/:orderId`,
  UPDATE_PRE_ORDER_STATE: `${environment.baseApiUrl}/im/admin/pre-order/:orderId/state`,
  SAVE_COMMENT: `${environment.baseApiUrl}/im/admin/order/:orderId/comment`,
  GET_ORDER_COMMENTS: `${environment.baseApiUrl}/im/admin/order/:orderId/comment`,
  UPDATE_COMMENT: `${environment.baseApiUrl}/im/admin/order/:orderId/comment/:commentId`,
  DELETE_COMMENT: `${environment.baseApiUrl}/im/admin/order/:orderId/comment/:commentId`,
  UPDATE_ORDER_COLLABORATOR: `${environment.baseApiUrl}/im/admin/order/:orderId/collaborator`,

  CHECK_INVOICE_STATUS: `${environment.baseApiUrl}/checkout/store-order/invoice/:orderInvoiceId/status`,
});

export type CustomerRequest = {
  firstName: string,
  lastName: string,
  phone: string,
  email: string,
  identificationNumber: string,
  identificationType: string,
};

export type ItemRequest = {
  productId: string,
  quantity: number,
  comment?: string,
};

export type OrderRequest = {
  id: string,
  // storeId: string,
  // currency: string,
  // customer: CustomerRequest,
  // deliveryMethod: DeliveryMethodName,
  // shippingAddress: Address & {country: string},
  // paymentMethod: PaymentMethod,
  // items: ItemRequest[],
  // useShippingAsBilling?: boolean,
  // billingAddress?: Address & {country: string},
  orderCreationType?: 'PRE_ORDER' | 'DEFAULT' | 'MANUAL',
  receiptFile?: File,
  amountReceived?: string,
  state?: OrderState,
  previousState?: OrderState,
  force?: boolean,
  orderData?: {
    collaboratorId?: string,
  },
};

export const getOrderApi = getCreator(endpoints.GET_ORDER);
export const updateOrderStateApi = putCreator(endpoints.UPDATE_ORDER_STATE);
export const getPreOrderApi = getCreator(endpoints.GET_PRE_ORDER);
export const updatePreOrderStateApi = putCreator(
  endpoints.UPDATE_PRE_ORDER_STATE
);
export const addOrderReceiptApi = postCreator(endpoints.ADD_ORDER_RECEIPT);
// export const getAvailableRevertStatesApi = getCreator(
//   endpoints.GET_AVAILABLE_REVERT_STATES
// );
export const getOrderStockErrorsApi = getCreator(
  endpoints.GET_ORDER_STOCK_ERRORS
);
export const saveCommentApi = postCreator(endpoints.SAVE_COMMENT);
export const getOrderCommentsApi = getCreator(endpoints.GET_ORDER_COMMENTS);
export const updateCommentApi = putCreator(endpoints.UPDATE_COMMENT);
export const deleteCommentApi = deleteCreator(endpoints.DELETE_COMMENT);
export const updateOrderCollaboratorApi = postCreator(
  endpoints.UPDATE_ORDER_COLLABORATOR
);
export const checkInvoiceStatusApi = getCreator(endpoints.CHECK_INVOICE_STATUS);
